export default () => {
  $(document).on("variation_trigger", function (e, data) {
    let {description} = data

    $('.p-product-description').html(description)
  });
}
